export class Market {
  weapons!: {
    name: string;
    items: WeaponMarketItem[];
  }[];
  equipment!: {
    name: string;
    items: EquipmentMarketItem[];
  }[];
}

export type WeaponMarketItem = {
  id: string;
  name: string;
  cost: number;
  rarity: number;
  IsFaction: boolean;
};

export type EquipmentMarketItem = {
  id: string;
  name: string;
  cost: number;
  rarity: number;
  IsFaction: boolean;
};
